// import * as common from '@/store/mutation-types';

/*
export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const SEARCH_PARAM = 'SEARCH_PARAM';
export const TABLE_LIST = 'TABLE_LIST';
*/

const SET = 'SET';

export default {
	// ...common,
	SET
	/*
	,
	SEARCH_PARAM,
	DEFAULT_ASSIGN,
	TABLE_LIST
	*/
};
